module.exports = __webpack_public_path__ + "static/spencer-e41d3f30c9cfe0b67965e337b3037e9d.svg";